module.exports = __webpack_public_path__ + "static/img/fascist_s.01d2d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/board/fascist_s.png
// module id = 254
// module chunks = 0